/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Action, PayloadAction } from '@reduxjs/toolkit';
import { Epic, StateObservable, ofType } from 'redux-observable';
import { Observable, catchError, concatMap, from, mergeMap, of } from 'rxjs';

import { Dependencies } from '@configurations/dependencies/dependencies';
import { RootState } from '@store/create-store';
import {
  subscribeToNotificationFailure,
  subscribeToNotificationSuccess,
} from '@store/scenario/subscription/subscription-slice';
import { displayToast } from '@store/toast-notifications/toast-notifications-slice';
import { ToastNotification } from '@scenario/models/toast-notification.model';

export const subscribeToNotificationEpic: Epic<Action, Action, RootState, Dependencies> = (
  action$: Observable<Action>,
  _state$: StateObservable<RootState>,
  dependencies: Dependencies,
) =>
  action$.pipe(
    ofType('subscription/subscribeToNotification'),
    concatMap((action: PayloadAction<{ sourceId: number; zoneId: number }>) =>
      from(dependencies.subscriptionGateway.subscribeToNotification(action.payload)).pipe(
        mergeMap((response: any) => {
          const toastNotification: ToastNotification = {
            title: 'Subscription to notification',
            content: 'c',
            status: 'info',
            closeIconButtonLabel: 'close',
            reference: dependencies.idProvider.generate(),
          };
          if (response.error_code === 7) {
            toastNotification.status = 'info';
            toastNotification.content = 'You have already subscribed to this Price Zone and Source';
          } else {
            toastNotification.status = 'success';
            toastNotification.content = 'Your subscription has been taken into account';
          }

          return of(subscribeToNotificationSuccess(response), displayToast(toastNotification));
        }),
        catchError(() =>
          of(
            subscribeToNotificationFailure('Unable to subscribe to notification'),
            displayToast({
              title: 'Subscription to notification',
              content: 'We are unable to create a subscription for this notification',
              status: 'danger',
              closeIconButtonLabel: 'close',
              reference: dependencies.idProvider.generate(),
            }),
          ),
        ),
      ),
    ),
  );
